import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import canUseDOM from "./canUseDOM.mjs";
import { useForkRef } from "./ref.mjs";
import { useContextTokens } from "./ThemeProvider.mjs";
export var useCssVariable = function useCssVariable(name, fallbackValue, ref) {
  var contextTheme = useContextTokens();
  var getValue = React.useCallback(function () {
    var _ref$current;
    if (contextTheme !== null && contextTheme !== void 0 && contextTheme[name]) return contextTheme[name];
    if (!canUseDOM()) return fallbackValue;
    var element = (_ref$current = ref === null || ref === void 0 ? void 0 : ref.current) !== null && _ref$current !== void 0 ? _ref$current : document.documentElement;
    var computedStyles = getComputedStyle(element);
    return computedStyles.getPropertyValue(name) || fallbackValue;
  }, [name, ref, fallbackValue, contextTheme]);
  var initialValue = React.useMemo(getValue, [getValue]);
  var _React$useState = React.useState(initialValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  React.useEffect(function () {
    return setValue(getValue);
  }, [getValue]);
  return value;
};
export var cssVariableEnhance = function cssVariableEnhance(_ref) {
  var variable = _ref.variable,
    fallback = _ref.fallback,
    prop = _ref.prop,
    map = _ref.map;
  return function (props) {
    var _ref2 = props,
      ref = _ref2.ref;
    var nodeRef = React.useRef();
    var variableValue = useCssVariable(variable, fallback, nodeRef);
    var mappedValue = React.useMemo(function () {
      return map ? map(variableValue) : variableValue;
    }, [map, variableValue]);
    return _objectSpread(_objectSpread({}, props), {}, _defineProperty({
      ref: useForkRef(ref, nodeRef)
    }, prop, props[prop] === undefined ? mappedValue : props[prop]));
  };
};
//# sourceMappingURL=useCssVariable.mjs.map